import { css } from "@emotion/react";

export const indexWrapCss = css`
    padding: 0 0;
    margin: 0 auto;
    display: flex;
    background-color: white;
    flex-direction: column;
    overflow-x: hidden;
`;


export const widthCss = css`
  /*  margin: 0 auto;*/
    display: flex;
    min-width: 1200px;
    padding: 120px 0px;
    flex-direction: column;
    justify-content: center;
    
`;